// @flow
import { useTranslator } from '@gandi/translate';

import { Base } from '@gandi/ui';

import DomainPageTitle from 'src/components/DomainPageTitle';
import { Layout } from 'src/components/Layout';

import DomainInput from '../components/DomainInput';

import { DomainList } from './DomainList';
import { TransferCommercialBlock } from './TransferCommercialBlock';

const inputId = 'search';

export function TransferPage(): React.MixedElement {
  const translator = useTranslator();

  const title = <DomainPageTitle process="transfer" />;

  return (
    <Layout>
      <Base marginBottom="base">
        <DomainInput
          id={inputId}
          process="transfer"
          title={title}
          label={translator.__('Transfer a domain name')}
        />
      </Base>
      <DomainList />
      <TransferCommercialBlock />
    </Layout>
  );
}
